import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { Toaster } from 'sonner';

import type { RouterContext } from '@/main';

export const Route = createRootRouteWithContext<RouterContext>()({
	component: () => (
		<div className="flex h-full flex-col">
			<Outlet />
			<Toaster position="top-center" richColors offset="calc(var(--safe-area-top) + 16px)" />
		</div>
	),
});
